// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2j-Ta"};